import React, { Component } from "react";
import { Modal, Form as FormInitial, Select, Button } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import {
    InputNumberItem,
    SelectItem,
    FormItem,
    Form,
    ErrorItem
} from "../../../../Components/Items";

const { Option } = Select;

class ModalSplitInsumo extends Component {
    formRef = React.createRef();

    handleOk = () => {
        const form = this.formRef.current;

        form
            .validateFields()
            .then((values) => {
                const partidas = values.partidas || [];
                this.props.onOk(partidas);
            })
            .catch((e) => ErrorItem(e));
    };

    onFinishFailed(e) {
        ErrorItem(e);
    }

    render() {
        const {
            visible,
            onCancel,
            proyectos = [],
            cantidad = 0,
            insumo,
        } = this.props;

        const descripcionInsumo = insumo?.descripcion || "";

        return (
            <Modal
                visible={visible}
                title="Dividir insumo en partidas"
                onCancel={onCancel}
                onOk={this.handleOk}
                destroyOnClose
                width={900}
            >
                {/* Nombre del insumo y cantidad original */}
                <div style={{ marginBottom: 10 }}>
                    {descripcionInsumo && (
                        <div>
                            <b>Insumo:</b> {descripcionInsumo}
                        </div>
                    )}
                    <div>
                        <b>Cantidad original:</b> {cantidad}
                    </div>
                </div>

                <Form
                    ref={this.formRef}
                    layout="vertical"
                    initialValues={{
                        partidas: [{}, {}],
                    }}
                    onFinishFailed={this.onFinishFailed}
                >
                    <table className="table" style={{ width: "100%", marginBottom: 10 }}>
                        <thead>
                            <tr>
                                <th className="th-border" style={{ width: "30%", padding: 6 }}>Proyecto</th>
                                <th className="th-border" style={{ width: "30%", padding: 6 }}>Subproyecto</th>
                                <th className="th-border" style={{ width: "20%", padding: 6 }}>Cantidad</th>
                                <th className="th-border" style={{ width: "20%", padding: 6 }}>Acción</th>
                            </tr>
                        </thead>

                        <FormInitial.List name="partidas">
                            {(fields, { add, remove }) => (
                                <tbody>
                                    {fields.map((field) => (
                                        <tr key={field.key}>
                                            {/* Proyecto */}
                                            <td className="td-border">
                                                <FormItem
                                                    {...field}
                                                    name={[field.name, "proyectoId"]}
                                                    fieldKey={[field.fieldKey, "proyectoId"]}
                                                    required
                                                    noStyle
                                                >
                                                    <SelectItem
                                                        placeholder="Proyecto"
                                                        style={{ width: "100%" }}
                                                        showSearch
                                                        optionFilterProp="children"
                                                    >
                                                        {proyectos.map((p) => (
                                                            <Option key={p._id} value={p._id}>
                                                                {p.nombre}
                                                            </Option>
                                                        ))}
                                                    </SelectItem>
                                                </FormItem>
                                            </td>

                                            {/* Subproyecto */}
                                            <td className="td-border">
                                                <FormItem noStyle shouldUpdate>
                                                    {({ getFieldValue }) => {
                                                        const proyectoId = getFieldValue([
                                                            "partidas",
                                                            field.name,
                                                            "proyectoId",
                                                        ]);

                                                        const proyecto = proyectos.find(
                                                            (p) => p._id === proyectoId
                                                        );

                                                        const subProyectos = proyecto?.subProyectos || [];

                                                        return (
                                                            <FormItem
                                                                name={[field.name, "subProyectoId"]}
                                                                fieldKey={[field.fieldKey, "subProyectoId"]}
                                                                noStyle
                                                            >
                                                                <SelectItem
                                                                    placeholder="Subproyecto"
                                                                    style={{ width: "100%" }}
                                                                    disabled={!proyecto}
                                                                    allowClear
                                                                    showSearch
                                                                    optionFilterProp="children"
                                                                >
                                                                    {subProyectos.map((sp) => (
                                                                        <Option key={sp._id} value={sp._id}>
                                                                            {sp.nombre}
                                                                        </Option>
                                                                    ))}
                                                                </SelectItem>
                                                            </FormItem>
                                                        );
                                                    }}
                                                </FormItem>
                                            </td>

                                            {/* Cantidad */}
                                            <td className="td-border">
                                                <FormItem
                                                    name={[field.name, "cantidad"]}
                                                    fieldKey={[field.fieldKey, "cantidad"]}
                                                    required
                                                    noStyle
                                                >
                                                    <InputNumberItem
                                                        min={0}
                                                        style={{ width: "100%" }}
                                                        placeholder="Cantidad"
                                                    />
                                                </FormItem>
                                            </td>

                                            {/* Botón eliminar */}
                                            <td
                                                className="td-border"
                                                style={{ textAlign: "center" }}
                                            >
                                                {fields.length > 1 && (
                                                    <Button
                                                        type="text"
                                                        danger
                                                        onClick={() => remove(field.name)}
                                                        icon={<DeleteOutlined />}
                                                    />
                                                )}
                                            </td>
                                        </tr>
                                    ))}

                                    {/* Botón agregar */}
                                    <tr>
                                        <td colSpan={4} style={{ paddingTop: 10 }}>
                                            <FormItem>
                                                <Button
                                                    type="dashed"
                                                    block
                                                    icon={<PlusOutlined />}
                                                    onClick={() => add()}
                                                >
                                                    Agregar partida
                                                </Button>
                                            </FormItem>
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </FormInitial.List>
                    </table>

                    {/* Calculadora de cantidad vs this.props.cantidad */}
                    <FormItem shouldUpdate>
                        {({ getFieldValue }) => {
                            const partidas = getFieldValue("partidas") || [];
                            const totalCapturado = partidas.reduce(
                                (acc, p) => acc + (Number(p?.cantidad) || 0),
                                0
                            );
                            const restante = Number(cantidad || 0) - totalCapturado;

                            return (
                                <div style={{ marginTop: 10 }}>
                                    <div>
                                        <b>Total capturado:</b> {totalCapturado}
                                    </div>
                                    <div>
                                        <b>Diferencia contra original:</b> {restante}
                                    </div>
                                </div>
                            );
                        }}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
}

export default ModalSplitInsumo;
